module.exports = __webpack_public_path__ + "static/media/production1.6b9c1268.jpg";